/* eslint-disable import/prefer-default-export */
import { ColumnProps, GridAction, ColumnType } from '@src/components/data.grid'
import type { ErrorState } from '../models'
import { toastSuccess, toastError } from '@src/utils/toast'

const onCopy = rowData => {
  const account = rowData?.account?.props?.description
  const description = rowData?.details?.props?.description
  const copiedError = account + ': ' + description
  return navigator?.clipboard?.writeText(copiedError)
}

export const getSnapshotErrorColumns: ColumnProps<ErrorState>[] = [
  {
    title: 'Source',
    field: 'account',
    width: 150
  },
  {
    title: 'Details',
    field: 'details',
    width: 250
  },
  {
    title: 'Status',
    field: 'status',
    width: 68
  },
  {
    type: ColumnType.actions
  }
]

export const getSnapshotErrorActions: GridAction<ErrorState>[] = [
  {
    handler: rowData => {
      onCopy(rowData)
        .then(() => {
          toastSuccess('The Error Details have been copied to clipboard!')
        })
        .catch(ex => {
          toastError(ex?.message || ex?.error || ex)
        })
    },
    icon: 'copy',
    iconType: 'cam-icons',
    title: 'Copy',
    description: 'Copy Error'
  }
]
